import { debounce } from './common/debounce';
class ElementWithTarget {
    constructor(progressbar, target) {
        this.progressbar = progressbar;
        this.target = target;
    }
}
export class ScrollProgress {
    constructor(win = window, doc = win.document) {
        this.win = win;
        this.doc = doc;
    }
    activate() {
        const elementsWithTargets = Array.from(this.doc.querySelectorAll('[data-progress]'))
            .map(element => element)
            .map(element => this.toElementWithTarget(element))
            .filter(element => !!element);
        if (elementsWithTargets.length > 0) {
            this.win.addEventListener('scroll', debounce(() => this.onScroll(elementsWithTargets)), false);
        }
    }
    toElementWithTarget(progressbar) {
        const targetQuery = progressbar.dataset.progress || 'body';
        if (!targetQuery)
            return undefined;
        const target = this.doc.querySelector(targetQuery);
        if (!target)
            return undefined;
        return new ElementWithTarget(progressbar, target);
    }
    onScroll(elementsWithTargets) {
        const winTop = this.win.scrollY;
        const winHeight = this.win.innerHeight;
        elementsWithTargets.forEach(({ progressbar, target }) => {
            const targetTop = target.offsetTop;
            const targetHeight = target.scrollHeight;
            if (winTop < targetTop) {
                return this.setProgress(progressbar, 0);
            }
            if (targetHeight < winHeight) {
                return this.setProgress(progressbar, 100);
            }
            const percentage = Math.round((winTop - targetTop) / (targetHeight - winHeight) * 100);
            return this.setProgress(progressbar, percentage);
        });
    }
    setProgress(progressBar, percent) {
        progressBar.style.width = `${percent}%`;
    }
}
